export default __webpack_public_path__ + "static/media/logo-name-2.827ea73a.png";